"use strict";

/* eslint global-require: 0 */
module.exports = require('./ReactSixteenAdapter');
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJtb2R1bGUiLCJleHBvcnRzIiwicmVxdWlyZSJdLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyIvKiBlc2xpbnQgZ2xvYmFsLXJlcXVpcmU6IDAgKi9cbm1vZHVsZS5leHBvcnRzID0gcmVxdWlyZSgnLi9SZWFjdFNpeHRlZW5BZGFwdGVyJyk7XG4iXSwibWFwcGluZ3MiOiI7O0FBQUE7QUFDQUEsTUFBTSxDQUFDQyxPQUFPLEdBQUdDLE9BQU8sQ0FBQyx1QkFBdUIsQ0FBQyJ9
//# sourceMappingURL=index.js.map